import React, { useEffect } from "react";
import Slider from "src/components/slider";
import { Opportunity } from "src/types/conversations";
import Button from "src/components/button";

import styles from "./removeDeal.module.scss";
import _ from "lodash";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";

interface IRemoveDeal {
  show: boolean;
  onClose: () => void;
  opportunity : string | null;
  onRemove : () => void;
  conversationId: string;
}

const RemoveDeal: React.FC<IRemoveDeal> = ({show, onClose, opportunity, onRemove, conversationId }) => { 
  const item = useSelector((state:RootState) => {
   
   const conversationState =  _.get(state.conversations.conversation,`${conversationId}`);
   const conversation = _.get(conversationState,"item")
   const selectedOpportunity = (_.get(conversation,"opportunities") || []).find((item:Opportunity) => item.id === opportunity)
   return selectedOpportunity || null
  }
  )

  useEffect(() => {
    if(!item) {
      onClose()
    }
  }, [item])
  
  return (
    <Slider.Dialog show={show} width="25rem" onClose={onClose}>
      <Slider.Header className={styles.header}>
        <div className={styles.titleContainer}>
          <div className={styles.title}>remove deal</div>
          <div className={styles.subtitle}>{_.get(item,"name")}</div>
        </div>
        <div className={styles.close} onClick={onClose}>
          <i className="icon-close" />
        </div>
      </Slider.Header>

      <Slider.Body className={styles.body}>
        <p className={styles.content}>
          Are you sure ? would you like to remove this deal value?
        </p>
      </Slider.Body>

      <Slider.Actions>
        <Button
          variant="primary"
          icon="paperflite-tick"
          disabled={_.get(item,"removing")}
          onClick={onRemove}
          text={_.get(item,"removing") ? "removing..." : "confirm"}
        />
        <Button text="cancel" onClick={onClose} />
      </Slider.Actions>
    </Slider.Dialog>
  );
};

export default RemoveDeal;
